import React, { Component } from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";

import Box from "pages/_components/Box";
import I18n from "pages/_components/I18n";
import Button from "pages/_components/Button";

const recoveryI18n = {
    password: "recoveryPassword",
    username: "recoveryUsername",
};

class Step4Content extends Component {
    send = (event) => {
        this.props.dispatch(push("/"));
    };

    render() {
        const recoveryType = this.props?.match?.params?.recoveryType;

        return (
            <form className="above-the-fold login-desktop-wrapper">
                <Box className="mb-8" display="flex" alignX="center">
                    <I18n
                        component="h2"
                        componentProps={{ className: "title-content text-center" }}
                        id={`${recoveryI18n[recoveryType]}.step4.text1`}
                    />
                </Box>

                <Box display="flex" alignX="center">
                    <I18n
                        component="p"
                        componentProps={{ className: "text-center" }}
                        id="recoveryPassword.step4.text2"
                    />
                </Box>

                <Button
                    className="mt-8"
                    label="global.login"
                    loading={false}
                    onClick={this.send}
                    type="button"
                    bsStyle="primary"
                />
            </form>
        );
    }
}

export default connect(null)(Step4Content);
